var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 4H8C8.44183 4 8.8 4.35817 8.8 4.8C8.8 5.21027 8.49117 5.54841 8.0933 5.59462L8 5.6H6.4C5.98973 5.6 5.65159 5.90883 5.60538 6.3067L5.6 6.4V17.6C5.6 18.0103 5.90883 18.3484 6.3067 18.3946L6.4 18.4H17.6C18.0103 18.4 18.3484 18.0912 18.3946 17.6933L18.4 17.6V16C18.4 15.5582 18.7582 15.2 19.2 15.2C19.6103 15.2 19.9484 15.5088 19.9946 15.9067L20 16V17.6C20 18.8781 19.0009 19.9229 17.741 19.9959L17.6 20H6.4C5.12186 20 4.07707 19.0009 4.00407 17.741L4 17.6V6.4C4 5.12186 4.99914 4.07707 6.25898 4.00407L6.4 4ZM19.2 4L19.2648 4.0024L19.3606 4.01619L19.4497 4.03979L19.5386 4.07494L19.6166 4.1168L19.6934 4.17023L19.7657 4.23431L19.8429 4.32375L19.9003 4.41275L19.9251 4.46152L19.9521 4.52668L19.9713 4.58721L19.9945 4.70552L20 4.8V9.6C20 10.0418 19.6418 10.4 19.2 10.4C18.7582 10.4 18.4 10.0418 18.4 9.6V6.7312L13.3657 11.7657C13.0773 12.0541 12.6235 12.0763 12.3097 11.8322L12.2343 11.7657C11.9459 11.4773 11.9237 11.0235 12.1678 10.7097L12.2343 10.6343L17.2672 5.6H14.4C13.9582 5.6 13.6 5.24183 13.6 4.8C13.6 4.35817 13.9582 4 14.4 4H19.2Z",
    fill: "#FFDCA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopSvg);
export default __webpack_public_path__ + "static/media/ShopSVG.7c4e5d9dc950d8b31e54e86404304cc3.svg";
export { ForwardRef as ReactComponent };